import React, { useEffect, useState } from 'react';
import "./FaqContent.css";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { security_key, Url } from '../../../Services/Api';
import BottomToust from '../../BottomToust/BottomToust';
import MainLoader from '../../UI-Controls/MainLoader/MainLoader';

export default function FAQContent() {

    const location = useLocation();
    const data = location.state;

    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openToust, setOpenToust] = useState(false);
    const [message, setMessage] = useState("");

    const handleOpenToust = (message) => {
        setOpenToust(true);
        setMessage(message);

        const timeout = setTimeout(() => {
            setOpenToust(false);
        }, 1500);
        return () => clearTimeout(timeout);
    }

    const handleCloseToust = () => {
        setOpenToust(false);
    }


    const [faqContent, setFaqContent] = useState({
        heading: "",
        paragraph: ""
    });

    const [originalContent, setOriginalContent] = useState({
        heading: "",
        paragraph: ""
    });

    // GET FAQ by slug
    const getFaqsBySlug = async () => {
        try {
            setLoading(true)
            const res = await axios.get(
                `${Url}/api/v1/category-faqs/get-by-slug/${data.slug}`
            );

            if (res.data?.data) {
                const content = {
                    heading: res.data.data?.content?.heading || "",
                    paragraph: res.data.data?.content?.paragraph || "",
                };

                setFaqContent(content);
                setOriginalContent(content);

                // If empty → allow edit directly
                if (!content.heading && !content.paragraph) {
                    setEditMode(true);
                }
                setLoading(false)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.error("Error fetching FAQs:", error);
        }
    };

    useEffect(() => {
        if (data?.slug) {
            getFaqsBySlug();
        }
    }, [data?.slug]);

    // HANDLE CHANGE
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFaqContent((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    // ADD / UPDATE API (SAME ENDPOINT)
    const handleUpdate = async () => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };


            await axios.post(
                `${Url}/api/v1/category-faqs/add-update-content`,
                {
                    ref_id: data.ref_id,
                    heading: faqContent.heading,
                    paragraph: faqContent.paragraph
                }, { headers: headers }
            );

            setOriginalContent(faqContent);
            setEditMode(false)
            setLoading(false);

            handleOpenToust("Content saved successfully");


        } catch (error) {
            setLoading(false);
            console.error(error);
            handleOpenToust("Failed to save content");
        }
    };

    // CANCEL → restore old data
    const handleCancel = () => {
        setFaqContent(originalContent);
        setEditMode(false);
    };

    return (
        <div className="faq_content">

            <div className='faq-editor-head'>
                <h3>{data?.title} Content</h3>

                {/* SHOW EDIT BUTTON ONLY IF DATA EXISTS */}
                {!editMode && (
                    <button
                        className="update_btn_opt_1"
                        onClick={() => setEditMode(true)}
                    >
                        Edit Content
                    </button>
                )}
            </div>

            {/* HEADING */}
            <div className="faq_field">
                <p className="faq_field_heading">Heading</p>

                <textarea
                    style={{ height: "40px" }}
                    name="heading"
                    value={faqContent.heading}
                    disabled={!editMode}
                    onChange={handleChange}
                    className="General-Editor-Text-Area"
                    placeholder="Heading"
                />
            </div>

            {/* DESCRIPTION */}
            <div className="faq_field">
                <p className="faq_field_heading">Description</p>

                <textarea
                    style={{ height: "300px" }}
                    name="paragraph"
                    value={faqContent.paragraph}
                    disabled={!editMode}
                    onChange={handleChange}
                    className="General-Editor-Text-Area"
                    placeholder="Description"
                />
            </div>

            {/* BUTTONS */}
            {editMode && (
                <div className="buttons_list_bottom">

                    <button
                        onClick={handleCancel}
                        className="update_btn_opt_2"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={handleUpdate}
                        className="update_btn_opt_1"
                    >
                        Update
                    </button>

                </div>
            )}

            <BottomToust
                message={message}
                showMessage={openToust}
                handleCloseToust={handleCloseToust}
            />

            {loading && <div className="backdrop">
                <div className="loader-container">
                    <MainLoader heading1={"Updating Flyer Content"} />
                </div>
            </div>}



        </div>
    );
}